export const QA_HOST = 'https://api-qa.syfbank.com';
export const AKAMAI_HOST = 'https://images.synchronycredit.com';
export const DEV_HOST = 'https://dev.synchronycredit.com';
//# sourceMappingURL=env.js.map